export default "__VITE_ASSET__C0d_P$HF__"